<template>
    <div class="tc-configurator-left-sidebar">
        <LeftSidebarTabs/>
        <div class="tc-name-input-container">
            <NameInput v-if="storeUI.leftSidebarTab  === 'case'"
                       :value="storeProjectStructure.getCaseById(storeProjectStructure.selectedCaseId)?.name ?? ''"
                       @change="(value) => {
                           storeProjectStructure.setCaseNameById(storeProjectStructure.selectedCaseId, value)}"/>
            <NameInput v-if="storeUI.leftSidebarTab  === 'project'"
                       :value="storeProjectStructure.projectName"
                       @change="(value) => storeProjectStructure.setProjectName(value)"/>
        </div>
        <LeftSidebarCase v-if="storeUI.leftSidebarTab  === 'case'"/>
        <LeftSidebarProjects v-else/>

        <div class="tc-add-project-space"
             v-if="storeUI.leftSidebarTab  === 'project'">
            <div class="tc-borderline-horizontal"></div>
            <OutlineButton :text="'+ Добавить новый шкаф'"
                           @click="addNewCase()"/>
        </div>
        <div v-else></div>

    </div>
</template>

<script>
import NameInput from '@/UI/LeftSidebar/Components/nameInput.vue';
import LeftSidebarCase from '@/UI/LeftSidebar/Components/LeftSidebarCase.vue';
import LeftSidebarProjects from '@/UI/LeftSidebar/Components/LeftSidebarProjects.vue';
import { useStoreUI } from '@/Store/storeUI';
import LeftSidebarTabs from '@/UI/LeftSidebar/Components/LeftSidebarTabs.vue';
import OutlineButton from '@/UI/CommonComponents/OutlineButton.vue';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { roleCheck } from '@/libs/roleCheck';

export default {
    name: 'TheLeftSidebar',
    components: {
        OutlineButton,
        LeftSidebarTabs,
        LeftSidebarProjects,
        LeftSidebarCase,
        NameInput,
    },
    setup() {
        const storeUI = useStoreUI();
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const storeProjectStructure = useStoreProjectStructure();
        return {
            storeUI,
            storeCaseConfiguration,
            storeProjectStructure,
        };
    },
    methods: {
        addNewCase() {
            // TODO check if unsaved changes. Skip alert if all saved
            this.storeUI.setActiveModalName('unsavedCaseAlert');
            this.storeUI.setIsShowModal(true);
        },
    },
    computed: {
        isValidatedRole() {
            return roleCheck([ 'dealer', 'employee', 'user' ]);
        },
    },
};
</script>

<style scoped lang="scss">
.tc-configurator-left-sidebar {
    background-color: #ffffff;
    height: 100%;
    width: 300px;
    pointer-events: all;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 15px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.tc-name-input-container {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding: 0 15px;
    display: flex;
}

.tc-add-project-space {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2px 15px 15px 15px;
    gap: 15px;
    width: 100%;
    box-sizing: border-box;
    height: max-content;
}
</style>
